import React from 'react';
import { Flame, Shield, Swords, Target } from 'lucide-react';

export const computeStandings = (games) => {
  const chronological = [...games].sort((a, b) => a.date.localeCompare(b.date));
  const wins = chronological.filter((g) => g.result.outcome === 'win').length;
  const losses = chronological.filter((g) => g.result.outcome === 'loss').length;
  const ties = chronological.length - wins - losses;
  const pointsFor = chronological.reduce((sum, g) => sum + g.result.patriotsScore, 0);
  const pointsAgainst = chronological.reduce((sum, g) => sum + g.result.opponentScore, 0);
  const margin = chronological.length ? (pointsFor - pointsAgainst) / chronological.length : 0;
  let streak = { outcome: null, length: 0 };
  for (let i = chronological.length - 1; i >= 0; i -= 1) {
    const outcome = chronological[i].result.outcome;
    if (streak.outcome && streak.outcome !== outcome) break;
    streak = { outcome, length: streak.length + 1 };
  }
  const lastThree = chronological.slice(-3).reverse().map((g) => g.result.outcome[0].toUpperCase());
  return { wins, losses, ties, pointsFor, pointsAgainst, margin, streak, lastThree, games: chronological.length };
};

const STREAK_LABEL = { win: 'W', loss: 'L', tie: 'T' };

export const SeasonStandingsCard = ({ games }) => {
  if (!games?.length) return null;
  const s = computeStandings(games);
  const record = `${s.wins}-${s.losses}${s.ties ? `-${s.ties}` : ''}`;
  const margin = `${s.margin > 0 ? '+' : ''}${s.margin.toFixed(1)}`;
  const cells = [
    [Shield, 'Record', record, 'record'],
    [Target, 'Points For / Against', `${s.pointsFor} / ${s.pointsAgainst}`, 'points'],
    [Swords, 'Avg Margin', margin, 'margin'],
    [Flame, 'Streak', `${STREAK_LABEL[s.streak.outcome]}${s.streak.length}`, 'streak'],
  ];
  return (
    <div className="bg-[#0a1f44] text-white border-l-4 border-[#c8102e] p-5 sm:p-6 grid grid-cols-2 lg:grid-cols-[1fr_1fr_1fr_1fr_auto] gap-5" data-testid="season-standings">
      {cells.map(([Icon, label, value, key]) => (
        <div key={key} className="min-w-0">
          <div className="flex items-center gap-1.5 font-heading uppercase tracking-[0.25em] text-[9px] text-white/60"><Icon className="w-3 h-3 text-[#f4b400]" aria-hidden="true" /> {label}</div>
          <div className="font-display text-3xl sm:text-4xl tabular-nums leading-none mt-1" data-testid={`season-standings-${key}`}>{value}</div>
        </div>
      ))}
      <div className="col-span-2 lg:col-span-1 min-w-0">
        <div className="font-heading uppercase tracking-[0.25em] text-[9px] text-white/60">Last {s.lastThree.length}</div>
        <div className="flex gap-1.5 mt-1.5" data-testid="season-standings-last">
          {s.lastThree.map((tag, i) => <span key={i} className={`w-9 h-9 flex items-center justify-center font-display text-lg ${tag === 'W' ? 'bg-emerald-600' : tag === 'L' ? 'bg-[#c8102e]' : 'bg-[#d97706]'}`}>{tag}</span>)}
        </div>
      </div>
    </div>
  );
};
